module.exports = __webpack_public_path__ + "static/media/cardiologie2.3ea376d9.jpg";